import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import colors from '@/design/colors';
import { Container as ToastContent } from '../ToastContent/styles';

const AppToastContainer = styled(ToastContainer).attrs({
  position: 'bottom-left',
  autoClose: 4000,
  limit: 1,
  hideProgressBar: true,
  closeButton: false,
})`
  /* React-Toastify */
  /* https://github.com/fkhadra/react-toastify#readme */

  .Toastify__toast {
    padding: 0;
    margin: 0;
    overflow: inherit;
    border-radius: 0;
    box-shadow: none;
  }

  .Toastify__toast-body {
    padding: 0;
  }

  .Toastify__toast--default,
  .Toastify__toast--info,
  .Toastify__toast--success,
  .Toastify__toast--warning,
  .Toastify__toast--error,
  .Toastify__toast--dark {
    background-color: transparent;
  }

  .Toastify__toast--default {
    ${ToastContent} {
      background: ${colors.blackAlpha200};
    }
  }
  .Toastify__toast--info {
    ${ToastContent} {
      background: ${colors.purple100};
    }
  }
  .Toastify__toast--success {
    ${ToastContent} {
      background: ${colors.green};
    }
  }
  .Toastify__toast--warning {
    ${ToastContent} {
      background: ${colors.yellow};
    }
  }
  .Toastify__toast--error {
    ${ToastContent} {
      background: ${colors.red100};
    }
  }
  .Toastify__toast--dark {
    ${ToastContent} {
      background: ${colors.blackAlpha200};
    }
  }
`;

export default AppToastContainer;
